// extracted by mini-css-extract-plugin
export default {"upcomingInterviews":"styles_upcomingInterviews__CmRXM","rectangle":"styles_rectangle__0HntE","activityCol":"styles_activityCol__kdlVZ","centerAlign":"styles_centerAlign__kqE+o"};